import { useEffect, useState } from 'react';
import { api } from '../api';

// Object URLs enable audited dashboard requests; they are not a download-protection mechanism.
export function useImageVariantUrl(imageId: string | null, preset: number | null, revision?: string) {
  const [preview, setPreview] = useState<{ id: string | null; preset: number | null; url: string; error: string }>({ id: null, preset: null, url: '', error: '' });
  useEffect(() => {
    if (!imageId || !preset) return;
    const abort = new AbortController();
    let active = true;
    let url = '';
    void api.imageVariant(imageId, preset, abort.signal).then(blob => {
      if (!active) return;
      url = URL.createObjectURL(blob);
      setPreview({ id: imageId, preset, url, error: '' });
    }).catch(reason => {
      if (active) setPreview({ id: imageId, preset, url: '', error: reason instanceof Error ? reason.message : 'Image preview could not be loaded.' });
    });
    return () => { active = false; abort.abort(); if (url) URL.revokeObjectURL(url); };
  }, [imageId, preset, revision]);
  return preview.id === imageId && preview.preset === preset ? preview : { url: '', error: '' };
}
